import state from './moduleDocumentState.js'
import mutations from './moduleDocumentMutations.js'
import actions from './moduleDocumentAction.js'
import getters from './moduleDocumentGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
